import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExtractFromLoadService {
  options: any;
  instanceName: string;
  configType: string = 'EXTRACT';
  tabval = new BehaviorSubject('select');
  batchKey: string;
  authorizationData: any;
  authToken: string;
  projId: string;
  instanceList: string;
  tracksFromTable: any;
  extractBatchKey: string;
  configObj: any;
  token: any;
  batchKeyDetails: any;
  fromTable: boolean = false;
  requestedBy: string;
  Base_Url: string;
  Base_UI_BOT = DconConfigAPI.UI_PATH;


  paramData: any;
  getReportStatus: boolean = true;
  paramConfigObjEdit: any;
  UpdatedbatchKeyDetails: any[];
  batchKeyDetailEdit: any;
   localstorageToken = localStorage.getItem('authToken');  
  constructor(
    private dataSrv: DataService,
    private https: HttpClient) {
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    this.dataSrv.token.subscribe(val => {
      this.token = val;
      this.authToken = 'Bearer ' + this.token;
    });
    this.requestedBy = this.dataSrv.loggedUserId;

  }

  getisTrainStopUrl() {
    const isTrainStopUrl = this.dataSrv.getisTrainStopUrl();
    return isTrainStopUrl;
  }

  getfileSharePath() {
    return this.dataSrv.windowFileSharePath;
  }

  getExtractBatchkeys(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_BATCHKEY_UI + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Project_Name": this.projId,
      "Requested_By": this.dataSrv.loggedUserId,
      "Request_Type": DconConfigAPI.API_VARIABLES.Request_Type_Extract, //"EXTRACT",
      "Source": DconConfigAPI.API_VARIABLES.CLOUD //"CLOUD"
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getInstanceDetails(type: string): Observable<any> {
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_INSTANCE_DETAILS + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Source_Type": type,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getConfigDetails(type: string): Observable<any> {
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_CONFIG_DETAILS + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Request_Type": type,
      'Extract_Application': DconConfigAPI.API_VARIABLES.CLOUD,//'CLOUD'
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getParamsList():Observable<any> {
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_CLOUD_EXTRACT_LOV + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getExtractDetails(): Observable<any> {
    const payload = {
      token:this.authToken,
      assetName: DconConfigAPI.UIPATH_PROCESS_NAME
    };
    return this.https.post(DconConfigAPI.NODE_URL + "/uipath/uipath-releases",payload)
  }

  //DONE
  onExtract(body): Observable<any> {
  //   // let url = this.Base_UI_BOT+"/odata/Jobs/UiPath.Server.Configuration.OData.StartJobs";
  //   const url = this.Base_UI_BOT + DconConfigAPI.URL_PROPS.ODATA_JOBS_STARTJOBS;
  //   const headers = new HttpHeaders({
  //     'Authorization': this.authToken,
  //   });
  //   const options = { headers: headers };
  //   return this.https.post(url, body, options);
    // TODO - Need to remove the orgId and should come from API getOrdsCreds assetFold Id
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers: headers };

    const payload = {
      startInfo: body.startInfo,
      token: this.authToken,
      orgId: DconConfigAPI.OrganizationUnitId
    };
    return this.https.post(DconConfigAPI.NODE_URL + "/uipath/uipath-server-config-start-jobs", payload, options);  
  }

  onExtractUpdate(body): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.UPDATE_BATCHKEY_DETAILS + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.put(url, body, options);
  }


  onConfigSubmit(body): Observable<any> {
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.INSERT_BATCHKEY_DETAILS + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.post(url, body, options);
  }


  onConfigParamsSubmit(body):Observable<any>{
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.UPDATE_PARAMS_DETAILS + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.put(url, body, options);
  }

  getBatchKeyDetails(batchKey): Observable<any> {
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_BATCHKEY_DETAILS_UI + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Project_Name": this.projId,
      "Requested_By": this.dataSrv.loggedUserId,
      "Request_Type": DconConfigAPI.API_VARIABLES.Request_Type_Extract,//"EXTRACT",
      'Extract_Application': DconConfigAPI.API_VARIABLES.CLOUD,//'CLOUD',
      "Batch_Key": batchKey
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  downloadFilesFromTable(payloadObj): Observable<any> {

    const url = DconConfigAPI.NODE_URL + DconConfigAPI.URL_PROPS.CLOUD_EXTRACT_DOWNLOAD;
    if(environment.isBasicAuth){



const headers = new HttpHeaders({
  'Authorization': `Bearer ${this.localstorageToken}` 
});


payloadObj.isBasicAuth = true;

return this.https.post(url, payloadObj, { headers, responseType: 'arraybuffer' });
      
    }else{
   
  
    return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
    }
  }

  getSelectedBatchTasks(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_BATCHKEY_DATA + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Project_Name": this.projId,
      "Requested_By": this.dataSrv.loggedUserId,
      "Request_Type": DconConfigAPI.API_VARIABLES.Request_Type_Extract,
      "Source_Type": DconConfigAPI.API_VARIABLES.CLOUD
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  // getuipathCreds(){
  //   return this.dataSrv.uiPathCreds;
  // }

  //   // Api to get Authorization Token
  //   callUiPathAuthApi(body) {
  //     return this.https.post(DconConfigAPI.UI_PATH + "/api/account/authenticate", body);
  //   }

  getReport(id): Observable<any> {
    this.projId = this.dataSrv.projectID;
    const url = DconConfigAPI.NODE_URL + DconConfigAPI.URL_PROPS.GET_REPORT;
    
    const payloadObj :any= {
      "project":  this.projId,
      "instance": id
    };
  
    if (environment.isBasicAuth) {
    
  
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${this.localstorageToken}`
      });
  
      payloadObj.isBasicAuth = true;
  
      return this.https.post(url, payloadObj, { headers });
    } else {
      return this.https.post(url, payloadObj);
    }
  }
  
}

